import {
  FieldError,
  Group,
  Label,
  Text,
  TextArea,
  TextField as TextFieldBase,
  type TextFieldProps as TextFieldBaseProps,
} from "react-aria-components";
import { css, cx } from "../../../../styled-system/css";
import { inputClassNames } from "../styles/styles";
import type { ReactNode } from "react";

interface TextFieldProps extends TextFieldBaseProps {
  label?: ReactNode;
  description?: string;
  errorMessage?: string;
  className?: string;
  rows?: number;
  placeholder?: string;
  characterCount?: {
    show?: boolean;
    max?: number;
  };
}

export function TextAreaField({
  label,
  description,
  errorMessage,
  className,
  rows = 4,
  placeholder,
  characterCount,
  ...props
}: TextFieldProps) {
  const classes = inputClassNames({ override: "textarea" });
  return (
    <TextFieldBase isInvalid={!!errorMessage} {...props} className={cx(classes.fieldWrapper, className)}>
      {label && <Label className={classes.label}>{label}</Label>}
      <Group
        className={cx(
          classes.inputBox,
          // Workaround for https://github.com/adobe/react-spectrum/issues/7451
          props.isDisabled ?
            css({
              "&&&": { cursor: "not-allowed", backgroundColor: "lightgrey" },
            })
          : undefined,
        )}
      >
        <TextArea className={classes.input} rows={rows} placeholder={placeholder} />
      </Group>
      <span className={css({ color: "gray", fontSize: "small", textAlign: "end" })}>
        {characterCount?.show &&
          `${props.value?.length} ${characterCount.max ? ` / ${characterCount.max}` : ""} characters`}
      </span>
      {description && <Text slot="description">{description}</Text>}
      {errorMessage && <FieldError className={classes.error}>{errorMessage}</FieldError>}
    </TextFieldBase>
  );
}
